import AuthenticationRepository from './AuthenticationRepository.js'

export default class SessionStorageAuthenticationRepository extends AuthenticationRepository {
  _getAfterLogin = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem('afterLogin'))
    } catch (e) {
      return false
    }
  }

  getUrl = () => {
    return new Promise((resolve, reject) => {
      const afterLogin = this._getAfterLogin()
      afterLogin && afterLogin.url
        ? resolve(afterLogin.url)
        : reject(Error('SessionStorageAuthenticationRepository: getUrl error'))
    })
  }

  setLoggedEvent = () => {
    if (this._getAfterLogin()) {
      const afterLogin = this._getAfterLogin()
      window.sessionStorage.setItem('afterLogin', JSON.stringify({...afterLogin, event: 'logged'}))
    }
  }
}
